<template>
  <div class="changebtn">
    <div
      class="register-btn feeaccount-btn"
      :class="{'feeaccount-btn-active':type=='feeaccount'}"
      @click="changeType('feeaccount')"
    >
      <i></i>
      <span>{{$t('option.w34')}}</span>
    </div>
    <div
      v-if="LoanTotalAmount==0"
      class="register-btn management-btn"
      @click="instance()"
    >
      <i></i>
      <span>{{$t('option.w35')}}</span>
    </div>
    <div
      v-else
      class="register-btn management-btn"
      :class="{'management-btn-active':type=='management'}"
      @click="changeType('management')"
    >
      <i></i>
      <span>{{$t('option.w35')}}</span>
    </div>
    <div
      class="register-btn award-btn"
      :class="{'feeaccount-btn-active':type=='award'}"
      @click="changeType('award')"
    >
      <i></i>
      <span>{{$t('option.w71')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data(){
    return {
      LoanTotalAmount:''
    }
  },
  methods: {
    changeType(newType) {
      this.$emit("update:type", newType);
    },
    isMangement(){
      this.$axios.get('/Member/RZJFund/UserLoanTotalAmount')
      .then(res=>{
        if(res.err) return res.throw();
        this.LoanTotalAmount=res.LoanTotalAmount;
      })
    },
    instance(){
      const title = '温馨提示';
      const content = `<p>${this.$t('msg.m124')}</p>`;
        this.$Modal.info({
            title: title,
            content: content
        });
     }
  },
  created(){
    this.isMangement()
  },
  mounted(){
    if(this.$route.query.type=='management'){
      this.$emit("update:type", 'management');
    }
    if(this.$route.query.type=='award'){
      this.$emit("update:type", 'award');
    }
  }
};
</script>

<style lang="less" scoped>
.changebtn {
  display: flex;
  cursor: pointer;
  width: 300px;
  height: 32px;
  background: rgba(228, 235, 248, 1);
  border-radius: 16px;
  margin: 0 auto 35px;
  .register-btn {
    width: 122px;
    height: 28px;
    margin-top: 2px;
    margin-left: 2px;
    border-radius: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      width: 13px;
      height: 11px;
      display: inline-block;
      margin-right: 8px;
      background: url("../../assets/assetcenter/asset_icons.png") no-repeat;
      background-size: cover;
    }
    span {
      font-size: 12px;
      font-weight: 500;
      color: #65718a;
    }
  }
  .feeaccount-btn {
    i {
      background-position: 0 -15px;
    }
    span {
      margin-top: -2px;
    }
  }
  .award-btn{
    i {
      background-position: 0 -15px;
    }
  }
  .management-btn {
    margin:2px 10px 0 10px;
    i {
      background-position: 0 -40px;
    }
  }
  .feeaccount-btn-active {
    background: #fff;
    i {
      background-position: 0 -2px;
    }
    span {
      color: #232325;
    }
  }
  .management-btn-active {
    background: #fff;
    i {
      background-position: 0 -27px;
    }
    span {
      color: #232325;
    }
  }
}
</style>

